import { Injectable } from '@angular/core';
import { Device } from '@era/gateway-sdk';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { UnenrolledDeviceStoreActions } from '../unenrolled-device';

@Injectable()
export class UnenrolledDeviceResolver {
  constructor(private store: Store<Device>) {}

  resolve(): Observable<boolean> {
    this.store.dispatch(UnenrolledDeviceStoreActions.UnenrolledDeviceResolverActions.unenrolledDevicesRequested());
    return of(true);
  }
}
